export default __webpack_public_path__ + "static/media/remotize-green.11a6597f.png";